import { Module } from 'vuex'

import { GetTestCaseListUseCase } from '@/application/testCase/getTestCaseListUseCase'
import { TestCaseRepository } from '@/domain/repositories/testCase/TestCaseRepository'
import { TestCase } from '@/domain/value_objects/testCase/TestCase'

interface TestCaseState {
  testCaseList: TestCase[]
  isLoading: boolean
  error: string | null
}

export const testCaseModule = (repository: TestCaseRepository): Module<TestCaseState, any> => {
  const getTestCaseListUseCase = new GetTestCaseListUseCase(repository)

  return {
    namespaced: true,
    state: {
      testCaseList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setTestCaseList(state, { testCaseList }: { testCaseList: TestCase[] }) {
        state.testCaseList = testCaseList
      },
      setIsLoading(state, { isLoading }: { isLoading: boolean }) {
        state.isLoading = isLoading
      },
      setError(state, { error }: { error: string | null }) {
        state.error = error
      }
    },
    actions: {
      async getTestCaseList({ commit }, { problemId }: { problemId: string }) {
        commit('setIsLoading', { isLoading: true })
        try {
          const res = await getTestCaseListUseCase.getTestCaseList(problemId)
          commit('setTestCaseList', { testCaseList: res })
        } catch (e) {
          commit('setError', { error: e })
        } finally {
          commit('setIsLoading', { isLoading: false })
        }
      }
    },
    getters: {
      testCaseList: (state: TestCaseState) => state.testCaseList,
      isLoading: (state: TestCaseState) => state.isLoading,
      error: (state: TestCaseState) => state.error
    }
  }
}
